import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

const PrivacyPolicy: React.FC = () => {
   const [menuOpen, setMenuOpen] =  useState(false);
  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">
        <Header />

        {/* Breadcrumb Section */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage: "url(assets/img/bg/breadcumb-bg-4.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <img
            src="assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container z-index-common">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Privacy Policy</h1>

              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>Privacy Policy</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Privacy Policy Content */}
        <section className="space-top space-extra-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="vs-blog blog-style1">
                  <div className="blog-content">

                    <h3 className="blog-title">Information We Collect</h3>
                    <p className="blog-text">
                      We may collect personal details such as name, phone number,
                      email, shipping address, and payment-related transaction
                      data when you place an order or contact support.
                    </p>

                    <h3 className="blog-title">How We Use Your Data</h3>
                    <ul className="list-style1">
                      <li>To process and deliver your orders.</li>
                      <li>To share order updates and customer support.</li>
                      <li>To improve website experience and product offerings.</li>
                      <li>To send offers only when you opt in.</li>
                    </ul>

                    <h3 className="blog-title">Data Security</h3>
                    <p className="blog-text">
                      We use standard security practices to protect your personal
                      information. Sensitive payment information is handled
                      through secure payment gateway providers.
                    </p>

                    <h3 className="blog-title">Third-Party Services</h3>
                    <p className="blog-text">
                      We may use trusted third-party providers for shipping,
                      analytics, and payments. These partners only receive
                      information required to complete their specific services.
                    </p>

                    <h3 className="blog-title">Cookies</h3>
                    <p className="blog-text">
                      Our website may use cookies to remember preferences and
                      improve user experience. You can disable cookies via your
                      browser settings, though some features may be affected.
                    </p>

                    <h3 className="blog-title">Your Rights</h3>
                    <p className="blog-text">
                      You can request correction or deletion of your personal
                      information by contacting our support team.
                    </p>

                    <h3 className="blog-title">Contact</h3>
                    <p className="blog-text">
                      For privacy-related queries, email{" "}
                      <a href="mailto:Ninesisters0819@gmail.com">
                        Ninesisters0819@gmail.com
                      </a>{" "}
                      or call{" "}
                      <a href="tel:+918928218258">
                        (+91) 89282 18258
                      </a>.
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default PrivacyPolicy;